<template>
	<div>
		<Breadcrumb>
            <Breadcrumb-item>基础信息</Breadcrumb-item>
            <Breadcrumb-item>商品管理</Breadcrumb-item>
        </Breadcrumb>
        <Form :label-width="120" inline :model="searchGoodsForm"
                class="wms-search-wapper wms-mt20">
            <Form-item label="货主名称：" prop="owner" style="width: 280px;">
                <FormSelectSearch ref="ownerSelect" searchType="owner" v-model="searchGoodsForm.owner" :filterable="true"></FormSelectSearch>
            </Form-item>
            <Form-item label="商品编号：" prop="code" style="width: 280px;">
                <FormAutoSearch v-model="searchGoodsForm.code" searchType="goodsCode"></FormAutoSearch>
            </Form-item>
            <Form-item label="商品条码：" prop="barcode" style="width: 280px;">
                <FormAutoSearch v-model="searchGoodsForm.barcode" searchType="barcode"></FormAutoSearch>
            </Form-item>
            <Form-item label="商品名称：" prop="name" style="width: 280px;">
                <FormAutoSearch v-model="searchGoodsForm.name" searchType="goodsName"></FormAutoSearch>
            </Form-item>
            <Form-item label="商品类别：" prop="goodsCategoryName" style="width: 280px;">
                <Input v-model="searchGoodsForm.goodsCategoryName" size="small" placeholder="请输入商品类别" />
            </Form-item>
            <Form-item :label-width="10" style="width: auto">
                <Button size="small" class="wms-mr10 wms-btn-ghost" type="ghost" @click="queryGoodsList()">
                    搜索
                </Button>
                <Button type="ghost" size="small" class="wms-mr10 wms-btn-ghost" @click="clear">清空</Button>
            </Form-item>
        </Form>

        <IconBtnGroup :dataSource="btnGroup" @on-click="btnchange" class="wms-mt10" :columnDefs="columnDefs" @col-change="colChange"></IconBtnGroup>

        <div class="wms-mt10">
            <GridPage
                ref="refGridPage"
                :total="total"
                :curPage="curPage"
                :columnDefs="columnDefs"
                :rowData="rowData"
                @selectionChanged="selectChange"
                @sortChanged="sortChanged"
                @callbackGridPage="callbackGridPage"
            ></GridPage>
        </div>
		<Modal :title="modalTitle"
			   v-model="showMgrModel"
			   class-name="vertical-center-modal">
			<Form ref="formValidate" :label-width="120" :rules="ruleValidate" inline :model="chooseForm"
				  class="wms-form-check oneline">
				<Form-item label="模板类型：">
					商品打印模板
				</Form-item>
				<Form-item label="模板名称：" prop="name">
					<Select v-model="chooseForm.name" :clearable="true" style="width: 150px;">
						<Option v-for="ow in mubanData" :key="ow.code" :value="ow.url">{{ow.name}}</Option>
					</Select>
				</Form-item>
			</Form>

			<div slot="footer">
				<div>
					<Button type="ghost" size="large" @click="saveMuban('formValidate')">保存</Button>
					<Button type="ghost" size="large" @click="closeMgrModal">返回</Button>
				</div>
			</div>
		</Modal>

		<!-- 导入 -->
		<MgrUpload
				:showImportProps="modalExport"
				:action-url="actionUrl"
				@susccessCallback="importSuccess"
				@hideDialog="modalExport = false"
				:title="'商品导入'"
		></MgrUpload>
	</div>
</template>
<script>
    import {DefaultPageSize} from 'src/utils/const'
	import {_doForm} from 'src/utils/utils'
    import {InterObj} from 'src/utils/serviceConst'
    import IconBtnGroup from 'src/components/common/iconBtnGroup/iconBtnGroup.vue'
    import CellOperate from 'src/components/common/agTableComponent/cellOperate.vue'
    import FormAutoSearch from 'src/components/common/formSearch/formAutoSearch.vue'
    import FormSelectSearch from 'src/components/common/formSearch/formSelectSearch.vue'
    import MgrUpload from 'common/mgrUpload.vue'
    import store from 'storejs'
    import GridPage from 'common/grid-page.vue'

    export default {
        name: 'goods',
        data() {
            return {
                goodsNameList: [],							// 商品名字列表
                goodsNameListSearchloading: false,
                goodsCodeList: [],							// 商品名字列表
                goodsCodeListSearchloading: false,
                orderByClause: '',
                searchGoodsForm: {
                    owner: '',
                    code: '',
                    barcode: '',
                    name: '',
                    goodsCategoryName: ''
                },
                searchGoodsSaveForm: {},
                chooseForm: {
                    name: ''
                },
                ruleValidate: {
                    name: [
                        {required: true, message: '请选择模板', trigger: 'blur'}
                    ]
                },
                curTreeBreadData: [],
                ownerListData: [],
                mubanData: [],
                btnGroup: [
                    {
                        text: '新增',
                        icon: 'icon-Newly_added',
                        click: this.addGoods
                    },
                    {
                        text: '删除',
                        icon: 'icon-delete',
                        click: this.deleteGoods
                    },
                    {
                        text: '打印商品编号',
                        icon: 'icon-Print_management',
                        click: this.printBtn
                    },
                    {
                        text: '导入',
                        icon: 'icon-Order_import',
                        click: this.importBtn
                    },
                    {
                        text: '导出',
                        icon: 'icon-export',
                        click: this.export
                    },
                    {

                        text: '模板下载',
                        icon: 'icon-Download_templates',
                        click: this.mubanDownload
                    }
                ],
                modalTitle: '选择模板',
                showMgrModel: false,
                columnDefs: this.createColumnDefs(),
                rowData: [],
                curPage: 1,
                total: 0,
                DefaultPageSize: DefaultPageSize,
                selectArr: [],
                selectIds: [],
                selectCode: [],
                modalExport: false, // 导入弹框
                actionUrl: InterObj.goodsImport
            }
        },
        activated() {
            this.queryGoodsList(this.curPage)
        },
        mounted() {
            this.$Loading.start()
            this.$refs.ownerSelect.ajaxPromise.then(() => {
                this.$Loading.finish()
            })
        },
        components: {
            IconBtnGroup: IconBtnGroup,
            FormAutoSearch,
            FormSelectSearch,
            MgrUpload,
            GridPage
        },
        methods: {
            clear() {
                this.searchGoodsForm = {
                    owner: '',
                    code: '',
                    barcode: '',
                    name: '',
                    goodsCategoryName: ''
                }
            },
            // 导出
            export() {
                if (this.total === 0) {
                    return this.$Notice.warning({desc: '没有数据不允许导出'})
                }
                let url = `/cloudStorehouseWeb/goodsInfo/exportGoodsInfo`
                let paramArr = []
                for (let k in this.searchGoodsSaveForm) {
                    if (this.searchGoodsSaveForm[k]) {
                        paramArr.push(`${k}=${this.searchGoodsSaveForm[k]}`)
                    }
                }

                this.idsString && paramArr.push('goodsConfigIdStr=' + this.idsString)
                if (paramArr.length > 0) {
                    url += ('?' + paramArr.join('&'))
                }
                location.href = url
            },
            colChange(item) {
                this.columnDefs = item
            },
            // 查询商品列表
            async queryGoodsList(page) {
                this.$refs.refGridPage.deselectAll()
                this.curPage = Number(page) ? page : 1

                let searchGoodsForm = this.searchGoodsForm
                this.searchGoodsSaveForm = {...searchGoodsForm}

                let params = {
                    ...searchGoodsForm,
                    orderByClause: this.orderByClause,
                    page: this.curPage,
                    pageSize: this.DefaultPageSize
                }
                this.$refs.refGridPage.showLoadingOverlay()
                let res = await requestMethods.get(InterObj.queryGoodsList, params)
                this.$refs.refGridPage.hideOverlay()
                if (res.result === 'success') {
                    this.rowData = res.data
                    this.total = parseInt(res.count)
                    this.$Loading.finish()
                } else {
                    this.$Loading.error()
                    this.$Notice.warning({desc: res.msg})
                }
            },
            // 查模板
            async queryMuban() {
                let para = {type: '商品打印模板'}
                let res = await requestMethods.get(InterObj.queryMuban, para)
                if (res.result === 'success') {
                    this.mubanData = res.data
                } else {
                    this.$Loading.error()
                    this.$Notice.warning({desc: res.msg})
                }
            },
            importBtn() {
                this.modalExport = true
            },
            importSuccess() { // 导入成功
                this.queryGoodsList()
            },
            btnchange(params) {
                params.click()
            },
            printBtn() {
                let idsString = this.idsString
                if (idsString === '') {
                    return this.$Notice.warning({desc: '请先选择要操作的数据'})
                }

                this.queryMuban()
                this.showMgrModel = true
            },
            deleteGoods() {
                let self = this
                let idsString = this.idsString
                if (idsString === '') {
                    return this.$Notice.warning({desc: '请先选择要操作的数据'})
                }
                this.$Modal.confirm({
                    title: '删除',
                    content: '确认删除？',
                    onOk: () => {
                        requestMethods.post(InterObj.deleteGoods, {goodsConfigId: idsString}).then(res => {
                            // 部分成功就重新获取列表
                            self.queryGoodsList()
                            if (res.data.length) {
                                this.$MessageBox({content: res.data})
                            } else {
                                if (res.result === 'success') {
                                    self.$Message.success(res.msg)
                                } else {
                                    self.$Notice.warning({desc: res.msg})
                                }
                            }
                        })
                    }
                })
            },
            mubanDownload() {
                _doForm('/cloudStorehouseWeb/templateConfig/downloadTemplate', '_self', 'post', {type: '商品信息'})
            },
            closeMgrModal() {
                //  清空表单数据
                this.chooseForm = {
                    name: ''
                }
                //  关闭模态框
                this.showMgrModel = false
            },
            saveMuban(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        const codeKey = window.location.pathname + '-BASICPRINT'
                        store.set(codeKey, this.codeString)
                        let params = `fileUrl=${this.chooseForm.name}&codeKey=${codeKey}`
                        window.open('/print.html?printType=BASICPRINT&' + params)
                    }
                })
            },
            addGoods() {
                this.$router.push({name: 'goods-add'})
            },
            // 排序
            sortChanged(val) {
                this.orderByClause = val
                this.queryGoodsList()
            },
            callbackGridPage(val) {
                this.DefaultPageSize = val.pageSize
                this.queryGoodsList(val.page)
            },
            createColumnDefs() {
                let self = this
                return [
                    {
                        headerName: '',
                        field: 'selection',
                        pinned: 'left',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        width: 60,
                        maxWidth: 60,
                        minWidth: 60,
                        suppressSorting: true
                    },
                    {
                        headerName: '序号',
                        field: 'index',
                        pinned: 'left',
                        minWidth: 60,
                        width: 60,
                        cellRenderer: function(params) {
                            let index = Number(params.rowIndex) + 1
                            return '<span>' + index + '</span>'
                        }
                    },
                    {
                        headerName: '操作',
                        field: 'operate',
                        pinned: 'left',
                        width: 110,
                        minWidth: 110,
                        suppressSorting: true,
                        cellOperate: [
                            {
                                name: '查看',
                                click: function(params) {
                                    self.$router.push({
                                        name: 'goods-detail',
                                        query: {
                                            goodsCode: params.data.code
                                        }
                                    })
                                }
                            },
                            {
                                name: '编辑',
                                click: function(params) {
                                    self.$router.push({
                                        name: 'goods-edit',
                                        query: {
                                            goodsCode: params.data.code
                                        }
                                    })
                                }
                            }
                        ],
                        cellRendererFramework: CellOperate
                    },
                    {
                        headerName: '货主',
                        field: 'owner',
                        width: 300,
                        minWidth: 300
                    },
                    {
                        headerName: '商品条码',
                        field: 'barcode',
                        width: 100,
                        minWidth: 100
                    },
                    {
                        headerName: '商品编号',
                        field: 'code',
                        width: 100,
                        minWidth: 100,
                    },
                    {
                        headerName: '商品名称',
                        field: 'name',
                        width: 100,
                        minWidth: 100
                    },
                    {
                        headerName: '商品类别',
                        field: 'goodsCategoryName',
                        width: 100
                    },
                    {
                        headerName: '规格型号',
                        field: 'model',
                        width: 100
                    },
                    {
                        headerName: '单位',
                        field: 'unit',
                        width: 100
                    },
                    {
                        headerName: '颜色',
                        field: 'color',
                        width: 100
                    },
                    {
                        headerName: '保质期天数',
                        field: 'shelfLife',
                        width: 100
                    }
                ]
            },
            // 选中状态chanage事件
            selectChange(val) {
                this.selectArr = val
                this.selectIds = _.map(this.selectArr, 'goodsConfigId')
                this.selectCode = _.map(this.selectArr, 'code')
            }
        },
        computed: {
            idsString() {
                return this.selectIds.join(',')
            },
            codeString() {
                return this.selectCode.join(',')
            }
        }
    }
</script>

